﻿<script>
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";

	export let heading;
</script>


<FormRow class="justify-content-center confirmation-show">
	<FormColumn>
		<h2>{@html heading ? heading : "&nbsp;"}</h2>
	</FormColumn>
</FormRow>

<style>
	h2 {
        margin-bottom: 0 !important;
        margin-top: 16px;
    }
</style>
